/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockItemShareCtrl
 */
angular.module('mercury.modules.stock.item')
.controller('StockItemShareCtrl', ["companyId", "dialog", "itemIds", "$rootScope", "$scope", "StockSharedItems", "userinfo", function(companyId, dialog, itemIds, $rootScope, $scope, StockSharedItems, userinfo) {
  $scope.destinationCompanyId = null;

  var companies = userinfo.avaliableCompanies();

  if (companyId) {
    $scope.destinationCompanyId = companyId;

    $scope.loading = StockSharedItems.getSharePlan(itemIds, $scope.destinationCompanyId);
    $scope.loading.then(function(result) {
      $scope.currentCompany = companies[userinfo.activeCompany()];
      $scope.shareCompany = companies[$scope.destinationCompanyId];
      $scope.sharePlan = result;
    });
  } else {
    $scope.companies = [];
    angular.forEach(companies, function(company) {
      if (company.id != userinfo.activeCompany()) {
        $scope.companies.push({id: company.id, name: company.name});
      }
    });
  }

  $scope.siteSelected = function() {
    $scope.loading = StockSharedItems.getSharePlan(itemIds, $scope.destinationCompanyId);
    $scope.loading.then(function(result) {
      $scope.currentCompany = companies[userinfo.activeCompany()];
      $scope.shareCompany = companies[$scope.destinationCompanyId];
      $scope.sharePlan = result;
    });
  };

  $scope.confirmShare = function() {
    $scope.sharingItem = StockSharedItems.executeSharePlan($scope.sharePlan, $scope.destinationCompanyId);
    $scope.sharingItem.then(function() {
      angular.forEach($scope.sharePlan, function(sharePlanItem) {
        $rootScope.$broadcast('manageSharedItemUpdated', {
          id: sharePlanItem.localId,
          isShared: true
        });
      });

      $scope.$close();
    });
  };

  $scope.searchItems = function(searchStr) {
    return StockSharedItems.searchCompanyItems($scope.destinationCompanyId, searchStr);
  };
}]);
